export default __webpack_public_path__ + "static/media/contacto_1.4ca1b2d6.jpeg";